import { Dayjs } from 'dayjs';

const DayOfWeekFormatter = (date: Dayjs) => {
  const customDays = ['日', '月', '火', '水', '木', '金', '土']; // Custom day names starting from Monday
  const dayOfWeek = date.day(); // Get day of week as a number (0-6)
  return customDays[dayOfWeek];
};
export default DayOfWeekFormatter;